import React, { Component, useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { CardElement, Elements, injectStripe, StripeProvider } from "react-stripe-elements";

import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";
import FetchingClickShield from "js/react/components/FetchingClickShield";
import Api from "js/core/api";
import getLogger, { LogGroup } from "js/core/logger";
import withStripe from "js/react/views/UserOptions/Billing/withStripe";

import "css/billing.scss";

const logger = getLogger(LogGroup.BILLING);

const InjectedChangePaymentMethodDialog = injectStripe(
    function ChangePaymentMethodDialog(props) {
        const { closeDialog, stripe, orgId, callback = () => { } } = props;

        const [isSubmitting, setIsSubmitting] = useState(false);
        const [error, setError] = useState(null);

        const handleUpdatePaymentMethod = async orgId => {
            if (isSubmitting) return;

            setIsSubmitting(true);

            const { paymentMethod, error } = await stripe.createPaymentMethod("card");
            if (error) {
                setIsSubmitting(false);
                setError(error.message);
                logger.error(error, "stripe.createPaymentMethod() failed", { orgId });
                return;
            }

            try {
                const { requiresAction, clientSecret } = await Api.paymentMethods.post({
                    payment_method_id: paymentMethod.id,
                    organization_id: orgId
                });

                if (!requiresAction) {
                    callback(true);
                    closeDialog();
                    return;
                }

                const { error } = await stripe.handleCardPayment(clientSecret, {});
                if (error) {
                    throw error;
                }
                callback(true);
                closeDialog();
            } catch (err) {
                logger.error(err, "Api.paymentMethods.post() failed", { paymentMethodId: paymentMethod?.id, orgId });
                setError(err.message);
            }

            setIsSubmitting(false);
        };

        const hadleCloseDialog = () => {
            callback(false);
            closeDialog();
        };

        return (
            <BeautifulDialog className="update_payment_form" closeDialog={hadleCloseDialog}>
                <FetchingClickShield visible={isSubmitting} backgroundColor="white" />
                <DialogTitle>Update Payment Method</DialogTitle>
                <DialogContent>
                    <CardElement onChange={({ error }) => setError(error?.message ?? null)} />
                    {error && <div className="card-error">{error}</div>}
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={hadleCloseDialog}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => handleUpdatePaymentMethod(orgId)}>
                        Update Payment Method
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
);

class ChangePaymentMethodDialog extends Component {
    render() {
        const { stripe, ...props } = this.props;

        return (
            <StripeProvider stripe={stripe}>
                <Elements>
                    <InjectedChangePaymentMethodDialog {...props} />
                </Elements>
            </StripeProvider>
        );
    }
}

export default withStripe(ChangePaymentMethodDialog);
